import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IDatabaseDescriptionParams {
  id: string;
  description: string;
}

export class SetDatabaseDescriptionRequest extends Request<IDatabaseDescriptionParams, IResult> {
  constructor(params: IDatabaseDescriptionParams) {
    super('setDatabaseDescription', params);
  }
}
